import { EIntegrationKeys, type IIntegration } from '@types';
import VueYandex from 'vue3-yandex-metrika';

function useGtag(gaIds: string[]) {
  useHead({
    script: [
      { src: `https://www.googletagmanager.com/gtag/js?id=${gaIds[0]}`, async: true },
      {
        children: `
          window.dataLayer = window.dataLayer || [];
          window.gtag = (...args) => dataLayer.push(args);
          window.gtag('js', new Date());
          ${gaIds.map(id => `window.gtag('config', '${id}');`).join('\n          ')}
        `,
      },
    ],
  })
}

export function useMetrics() {
  const nuxtApp = useNuxtApp();
  const router = useRouter();

  const metrics = {
    [EIntegrationKeys.GTM]: false,
    [EIntegrationKeys.YandexMetrika]: false,
  };

  function init(integrations: IIntegration[]) {
    const gtags = nuxtApp.$config.public.BACKEND_URL?.includes('business') ? ['G-JZNBPZHDRX'] : [];

    integrations.forEach(i => {
      switch (i.key) {
        case EIntegrationKeys.GTM:
          gtags.unshift(i.value.code);
          metrics[EIntegrationKeys.GTM] = true;
          return
        case EIntegrationKeys.YandexMetrika:
          nuxtApp.vueApp.use(VueYandex, {
            id: i.value.code,
            env: getEnvironment(),
            router,
          });
          metrics[EIntegrationKeys.YandexMetrika] = true;
          return
        default:
          return;
      }
    });

    if (gtags.length) useGtag(gtags);
  }

  function addGoogleMetricEvent(command: Parameters<typeof gtag>[0], ...args: unknown) {
    if (!metrics[EIntegrationKeys.GTM]) return;
    try {
      window.gtag(command, ...args);
    } catch (e) {
      console.error('gtag event', e);
    }
  }

  return {
    init,
    addGoogleMetricEvent,
  };
}
